export default "__VITE_ASSET__BcNrLH$G__"